
function GeSelectStatusCtrl(TranslationService) {
    var ctrl = this;

    ctrl.translation = TranslationService.getActiveTranslation();    

    ctrl.titleClass = function (title) {
        if (title == 'Principal') {
            return 'title-principal';
        }
        else {
            return 'alternatives';
        }
    }

    ctrl.statusOfId = function (id) {
        if (id == ctrl.statusId) {
            return 'Status' + id;
        }
        else {
            return '';
        }
    };

    ctrl.selectOption = function (option, event) {
        ctrl.statusId = option.StatusID;
        ctrl.status = option;
        //if (option) {
        //    ctrl.toggleSelected(option);
        //    event.stopPropagation();
        //}
    };
}

GeSelectStatusCtrl.$inject = ['TranslationService'];

seedWebApp.component('geSelectStatus', {
    controller: GeSelectStatusCtrl,
    bindings: {
        statusId: '=',        
        status: '=',        
        disabled: '<',
        options: '<',
    },
    templateUrl: '/SPA/Components/ge-select-status.html'
});